/**************************************************
 * Nombre:       Tarjeta_Videos_Empresarial
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import {Player} from 'video-react';
import 'video-react/dist/video-react.css';
import {theme} from "../../Tema";


const Tarjeta_Videos_Empresarial = ({item, escogida}) => {
    const {sCell} = useResponsive()



    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={4}
            sx={{
                borderBottom: escogida === item.id ? 8 : 0,
                borderColor: theme.palette.primary.main,
                borderRadius: 0
            }}
        >


            <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                {/*}  <img src={item.img ? item.img : img_video} width={'80%'} height={'auto'}/>*/}
                <Player>
                    <source src={item.video} width={'100%'} height={'auto'} style={{borderRadius: 10}}/>
                </Player>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    spacing={1}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontWeight: 600, fontSize: 24}}>Video Uno</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontSize: 14}}>
                            {item.descripcion}
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'center', mt: 2, ml: -1.4}}>
                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            spacing={0}>


                        </Grid>

                    </Grid>

                </Grid>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Videos_Empresarial